export default __webpack_public_path__ + "static/media/corporate-avatar.b021991e.svg";